import type { TrackingServiceConfig } from './TrackingService';

export interface CampaignConfig extends TrackingServiceConfig {
    trackingTitles: Record<string, string>;
}

export interface PageContext {
    pageSlug: string;
    pageId: string;
    pageName: string;
    tag: string;
    isHomePage: boolean;
    isLastPage: boolean;
}

/** Alias for backwards compatibility with globals.ts consumers */
export type CanonicalGlobals = {
    sessionId: string;
    userId: string;
    pageSlug: string;
    pageId: string;
    campaignId: string;
    companyId: string;
    versionId: string;
    workspaceId: string;
    trackingVersion: string | undefined;
    trackingTitles: Record<string, string>;
};

export interface PipelineContext {
    perspectiveSessionId: string;
    localId: string;
    anonymousId: string;
    globalId: string;
    perspectivePageSlug: string;
    pageSlug: string;
    perspectivePageId: string;
    pageId: string;
    perspectiveCampaignId: string;
    campaignId: string;
    perspectiveCompanyId: string;
    companyId: string;
    perspectiveVersionId: string;
    versionId: string;
    workspaceId: string;
    trackingVersion: string | undefined;
    trackingTitles: Record<string, string>;
}

/**
 * Pipeline-compatible serialization of tracking context.
 * Matches the output shape of the old serializeForPipeline() in globals.ts.
 */
export const serializeForPipeline = (opts: {
    sessionId: string;
    userId: string;
    config: CampaignConfig;
    page: PageContext;
}): PipelineContext => ({
    perspectiveSessionId: opts.sessionId,
    localId: opts.sessionId,
    anonymousId: opts.userId,
    globalId: opts.userId,
    perspectivePageSlug: opts.page.pageSlug,
    pageSlug: opts.page.pageSlug,
    perspectivePageId: opts.page.pageId,
    pageId: opts.page.pageId,
    perspectiveCampaignId: opts.config.campaignId,
    campaignId: opts.config.campaignId,
    perspectiveCompanyId: opts.config.companyId,
    companyId: opts.config.companyId,
    perspectiveVersionId: opts.config.campaignVersionId,
    versionId: opts.config.campaignVersionId,
    workspaceId: opts.config.workspaceId,
    trackingVersion: opts.config.trackingVersion,
    trackingTitles: opts.config.trackingTitles,
});
